import React, { Component } from 'react';
import { Route, Prompt } from 'react-router-dom';

import TabStructure from '../../ui/tab';

import SubNav from '../sub-nav';

import BasicInfo from '../../../containers/event/purchase-request/basic-info-line-item';
import VendorInformation from '../../../containers/event/vendor-information/purchase-request';
import ErrorPage from '../../errorPage';
import Loading from '../../ui/loading-spinner';

class PurchaseRequest extends Component {
    render() {
        let successMessage = null;
        if (this.props.successMessage) {
            successMessage = (
                <div className="event__success">
                    <span onClick={this.props.clearMessage}>
                        <span className="visually-hidden">
                            Remove the success message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    <p>{this.props.successMessage}</p>
                </div>
            );
        }

        let errorMessage = null;
        if (this.props.errorMessage) {
            errorMessage = (
                <div className="event__error">
                    <span onClick={this.props.clearAllErrors}>
                        <span className="visually-hidden">
                            Remove the error message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    <p>{this.props.errorMessage}</p>
                </div>
            );
        }

        let formContent = [
            {
                path: 'basic-info-line-item',
                title: 'Basic Info & Line Item',
                content: <BasicInfo />
            },
            {
                path: 'vendor-information',
                title: 'Vendor Information',
                content: (
                    <VendorInformation
                        type="purchaseRequest"
                        purchaseRequestId={this.props.purchaseRequestId}
                    />
                )
            }
        ];

        const activeIndex = formContent.findIndex(
            item => item.path === this.props.match.params.tab
        );

        return activeIndex === -1 ? (
            <Route component={ErrorPage} />
        ) : (
            <div>
                {successMessage}
                {errorMessage}
                <SubNav
                    eventId={this.props.eventId}
                    contract={this.props.contract}
                    startDate={this.props.startDate}
                    prAccessible={this.props.prAccessible}
                    status={this.props.status}
                />
                {this.props.getPrLoading ? (
                    <Loading />
                ) : (
                    <div className="event__content">
                        <Prompt
                            when={this.props.location.pathname.startsWith(
                                '/event/purchase-request'
                            )}
                            message={location => {
                                return !location.pathname.startsWith(
                                    '/event/purchase-request'
                                )
                                    ? 'Do you wish to leave the page? Any unsaved changes will be lost.'
                                    : true;
                            }}
                        />
                        <div className="event__header">
                            <div className="event__event-name">
                                {this.props.eventName}
                            </div>
                        </div>

                        <TabStructure
                            items={formContent}
                            tab={this.props.match.params.tab}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default PurchaseRequest;



// WEBPACK FOOTER //
// ./src/components/event/purchase-request/index.js